import { Button, Tabs } from 'antd';
import cn from 'classnames';

import { MultipleSelect, Text } from '@app/components';
import { PREFIX, TASK_LIST_LABEL } from '@app/constants';
import { useTasksAccess } from '@app/hooks';
import { taskListTabs } from '@app/pages/TasksList/constants/taskListTabs';
import { useTaskListContext } from '@app/providers/TaskListProvider';
import type { NTaskListProvider } from '@app/providers/TaskListProvider/types';

import '@pages/TasksList/styles/TaskListPageHeader.desktop.scss';
import '@pages/TasksList/styles/TaskListPageHeader.tablet.scss';
import '@pages/TasksList/styles/TaskListPageHeader.mobile.scss';

export const TaskListPageHeader = () => {
  const {
    activeTab,
    onChangeTab,
    headerTitle,
    openCreateTaskModal,
    selectedEmployee,
    ownersFilterList,
    setSelectedEmployee,
  } = useTaskListContext();
  const { rightToCreateTask } = useTasksAccess();

  return (
    <div className={`${PREFIX}task-list-header`}>
      <div className="tasks-header-title left">
        <Text pattern="headline2" weight={600}>
          {TASK_LIST_LABEL}
        </Text>
        <Text
          color="#656363"
          className={cn('date-title', {
            'display-none': activeTab === 'registry',
          })}
        >
          {headerTitle}
        </Text>
      </div>
      {activeTab !== 'registry' && (
        <MultipleSelect
          defaultSelected={Boolean(selectedEmployee?.length)}
          className="user-selector"
          placeholder="Все ответственные"
          allOptions={ownersFilterList}
          selectedOption={selectedEmployee}
          setSelectedOptions={setSelectedEmployee}
          minWidth={225}
          filterName="filterName"
        />
      )}
      <div className="tasks-header-title right">
        <Tabs
          defaultActiveKey={activeTab}
          activeKey={activeTab}
          items={taskListTabs}
          onChange={(activeTab) =>
            onChangeTab(activeTab as NTaskListProvider.Tab)
          }
          size="large"
        />
        {rightToCreateTask && (
          <Button
            type="primary"
            className="action-button"
            onClick={openCreateTaskModal}
          >
            Создать задачу
          </Button>
        )}
      </div>
    </div>
  );
};
